"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfficeTheme = void 0;
var string_1 = require("@devexpress/utils/lib/utils/string");
var theme_drawing_color_collection_1 = require("./theme-drawing-color-collection");
var theme_font_scheme_1 = require("./theme-font-scheme");
var theme_format_scheme_1 = require("./theme-format-scheme");
var OfficeTheme = (function () {
    function OfficeTheme() {
        this.name = "";
        this.colors = new theme_drawing_color_collection_1.ThemeDrawingColorCollection();
        this.fontScheme = new theme_font_scheme_1.ThemeFontScheme();
        this.formatScheme = new theme_format_scheme_1.ThemeFormatScheme();
    }
    Object.defineProperty(OfficeTheme.prototype, "isValidate", {
        get: function () {
            return !string_1.StringUtils.isNullOrEmpty(this.name) && this.colors.isValidate && this.fontScheme.isValidate && this.formatScheme.isValidate;
        },
        enumerable: false,
        configurable: true
    });
    OfficeTheme.prototype.copyFrom = function (sourceObj) {
        this.name = sourceObj.name;
        this.colors.copyFrom(sourceObj.colors);
        this.fontScheme.copyFrom(sourceObj.fontScheme);
        this.formatScheme.copyFrom(sourceObj.formatScheme);
    };
    OfficeTheme.prototype.clear = function () {
        this.name = "";
        this.colors.clear();
        this.fontScheme.clear();
        this.formatScheme.clear();
    };
    OfficeTheme.prototype.clone = function () {
        var result = new OfficeTheme();
        result.copyFrom(this);
        return result;
    };
    return OfficeTheme;
}());
exports.OfficeTheme = OfficeTheme;
